import { render, staticRenderFns } from "./borrowerShareAppBySms.vue?vue&type=template&id=71e4bc6d&"
import script from "./borrowerShareAppBySms.vue?vue&type=script&lang=js&"
export * from "./borrowerShareAppBySms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports